var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "container" },
        [
          _vm.step == 1
            ? _c("div", { staticClass: "step-one" }, [
                _c("img", {
                  staticClass: "logo-img",
                  attrs: { src: require("@/assets/images/mkk_logo.png") },
                }),
                _vm._m(0),
                _c("div", { staticClass: "mobile" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Nomor WhatsApp (Handphone) Moms/Dads"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "value" },
                    [
                      _c("span", { staticClass: "prefix" }, [
                        _vm._v(_vm._s(_vm.number_prefix)),
                      ]),
                      _c("mt-field", {
                        staticClass: "row phone",
                        attrs: { placeholder: "8xx-xxxx-xxxx" },
                        model: {
                          value: _vm.form.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mobile", $$v)
                          },
                          expression: "form.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "protocol" }, [
                  _c("div", {
                    staticClass: "iconfont",
                    class: _vm.isAgree ? "icon-check" : "icon-no-check",
                    on: {
                      click: function ($event) {
                        _vm.isAgree = !_vm.isAgree
                      },
                    },
                  }),
                  _c("div", { staticClass: "text" }, [
                    _vm._v("Saya telah membaca dan menyetujui "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openAgree()
                          },
                        },
                      },
                      [_vm._v("Pernyataan, Syarat dan Ketentuan")]
                    ),
                    _vm._v(" dan "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openAgree()
                          },
                        },
                      },
                      [_vm._v("Cookie")]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "opt" }, [
                  _c(
                    "div",
                    {
                      staticClass: "send-code-but",
                      class: _vm.isCounting ? "disabled" : "",
                      attrs: { id: "captcha-button" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isCounting
                              ? "Coba lagi setelah " + _vm.countdown + " detik"
                              : "Kirim Kode OTP"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v("Masukkan Kode OTP"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "opt-number" },
                    [
                      _c("VerificationCodeInput", {
                        attrs: { length: 6 },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "login-but",
                    on: {
                      click: function ($event) {
                        return _vm.next()
                      },
                    },
                  },
                  [_vm._v("MASUK")]
                ),
                _c("div", { staticClass: "ad" }, [
                  _c("img", {
                    attrs: {
                      src: "https://sgp-cdn.makuku.com/makuku_web_cdn/assets/crm/ad.jpg",
                      alt: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openDetail()
                      },
                    },
                  }),
                ]),
              ])
            : _vm.step == 2
            ? _c("div", { staticClass: "step-two" }, [
                _c("img", {
                  staticClass: "logo-img",
                  attrs: { src: require("@/assets/images/mkk_logo.png") },
                }),
                _c("div", { staticClass: "form" }, [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("div", { staticClass: "field-title" }, [
                        _vm._v("Nama Mom / Dad"),
                      ]),
                      _c("mt-field", {
                        staticClass: "row",
                        attrs: { placeholder: "Silakan masukkan nama ibu" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                      _vm._m(1),
                      _c("div", { staticClass: "son_number" }, [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.subtraction()
                              },
                            },
                          },
                          [_vm._v("-")]
                        ),
                        _c("span", { staticClass: "number" }, [
                          _vm._v(_vm._s(_vm.form.son_number)),
                        ]),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.addition()
                              },
                            },
                          },
                          [_vm._v("+")]
                        ),
                      ]),
                      _vm._l(_vm.form.ages, function (value, index) {
                        return [
                          _c("div", { staticClass: "field-title" }, [
                            _vm._v("Tanggal Lahir Anak " + _vm._s(index + 1)),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "date-input",
                              class: { default: value == "" },
                              on: {
                                click: function ($event) {
                                  return _vm.openPicker(index)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(value ? value : "12/02/2020") + " "
                              ),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("Produk paling sering digunakan saat ini :"),
                      ]),
                      _c("div", { staticClass: "subtitle" }, [
                        _vm._v("*maksimal 3 produk"),
                      ]),
                      _c("mt-checklist", {
                        staticClass: "row",
                        attrs: { max: 3, options: _vm.product },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.form.product,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "product", $$v)
                          },
                          expression: "form.product",
                        },
                      }),
                      _vm.form.product.includes("Lainnya")
                        ? _c("mt-field", {
                            staticClass: "diy-product",
                            attrs: {
                              placeholder: "Silakan masukkan nama produk",
                            },
                            model: {
                              value: _vm.form.diy_product,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "diy_product", $$v)
                              },
                              expression: "form.diy_product",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("Ukuran Popok yang digunakan saat ini :"),
                      ]),
                      _c("mt-radio", {
                        staticClass: "row",
                        attrs: { options: _vm.size },
                        model: {
                          value: _vm.form.size,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "size", $$v)
                          },
                          expression: "form.size",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "submit",
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [_vm._v("Submit")]
                ),
              ])
            : _vm.step == 3
            ? _c("div", { staticClass: "step-three" }, [
                _vm._m(2),
                _c("div", { staticClass: "ad" }, [
                  _c("img", {
                    attrs: {
                      src: "https://sgp-cdn.makuku.com/makuku_web_cdn/assets/crm/ad_2.jpg",
                      alt: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openDetail()
                      },
                    },
                  }),
                ]),
              ])
            : _vm._e(),
          _c(
            "mt-popup",
            {
              staticClass: "month-popup",
              attrs: { position: "bottom" },
              model: {
                value: _vm.popupVisible,
                callback: function ($$v) {
                  _vm.popupVisible = $$v
                },
                expression: "popupVisible",
              },
            },
            [
              _vm.popupVisible
                ? _c(
                    "mt-picker",
                    {
                      attrs: {
                        slots: _vm.slots,
                        "value-key": "label",
                        showToolbar: true,
                      },
                      on: { change: _vm.onValuesChange },
                    },
                    [
                      _c("div", { staticClass: "toolbar" }, [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.cancel()
                              },
                            },
                          },
                          [_vm._v("Membatalkan")]
                        ),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.confirm()
                              },
                            },
                          },
                          [_vm._v("Mengonfirmasi")]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { attrs: { id: "captcha-element" } }),
          _c("mt-datetime-picker", {
            ref: "picker",
            attrs: {
              type: "date",
              startDate: new Date("2020/1/1"),
              endDate: new Date(),
              cancelText: "Batal",
              confirmText: "Konfirmasi",
            },
            on: { confirm: _vm.handleConfirm },
            model: {
              value: _vm.pickerValue,
              callback: function ($$v) {
                _vm.pickerValue = $$v
              },
              expression: "pickerValue",
            },
          }),
          _c(
            "mt-popup",
            {
              staticClass: "tip-content",
              model: {
                value: _vm.isRegistered,
                callback: function ($$v) {
                  _vm.isRegistered = $$v
                },
                expression: "isRegistered",
              },
            },
            [
              _c("img", {
                staticClass: "logo",
                attrs: { src: require("@/assets/images/mkk_logo.png") },
              }),
              _c("div", { staticClass: "title" }, [
                _c("img", {
                  staticClass: "warn",
                  attrs: { src: require("@/assets/images/warn.png") },
                }),
                _c("span", [_vm._v("SUDAH PERNAH TERDAFTAR")]),
                _c("img", {
                  staticClass: "warn",
                  attrs: { src: require("@/assets/images/warn.png") },
                }),
              ]),
              _c("div", { staticClass: "desc" }, [
                _vm._v(
                  "Terima kasih atas permintaan sample Moms/Dads Mohon maaf, dikarenakan Moms/Dads sudah terdaftar sebelumnya, untuk sample tidak dapat kami berikan. Tunggu program seru lainnya dari kami, ya!"
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "confirm-but",
                  on: {
                    click: function ($event) {
                      _vm.isRegistered = _vm.fasle
                    },
                  },
                },
                [_vm._v("Baik, Saya Mengerti")]
              ),
            ]
          ),
          _c(
            "mt-popup",
            {
              staticClass: "agree-content",
              model: {
                value: _vm.isShowAgree,
                callback: function ($$v) {
                  _vm.isShowAgree = $$v
                },
                expression: "isShowAgree",
              },
            },
            [
              _c("iframe", {
                attrs: {
                  src: "https://mozilla.github.io/pdf.js/web/viewer.html?file=https://sgp-cdn.makuku.com/makuku_web_cdn/assets/crm/protocol.pdf",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "confirm-but",
                  on: {
                    click: function ($event) {
                      _vm.isShowAgree = _vm.fasle
                    },
                  },
                },
                [_vm._v("Baik, Saya Mengerti")]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _vm._v("Mari bergabung dengan MAKUKU Community!"),
      _c("br"),
      _vm._v("Yuk, daftar dengan mengisi data di bawah ini."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-title" }, [
      _c("span", [_vm._v("Jumlah Anak")]),
      _c("span", { staticClass: "subtitle" }, [_vm._v("*dibawah 3 tahun")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel" }, [
      _c("div", { staticClass: "iconfont icon-radio1" }),
      _c("div", { staticClass: "tip" }, [
        _vm._v("Terima kasih banyak atas partisipasinya"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }